import {DataStatus, DynamicUi, FormControl, Separator} from 'platform/components';
import {Heading, Hide} from 'platform/foundation';

import {UseFormReturn, useWatch} from 'react-hook-form';

// eslint-disable-next-line no-restricted-imports -- Intended
import {path} from 'ramda';

import {useGetSchemaQuery} from '@dms/api/core';
import i18n from '@dms/i18n';

import {Nullish} from 'shared/web';

import type {FormValues} from '../types/FormValues';

interface CustomFieldsNotificationSettingsProps {
  formApi: UseFormReturn<FormValues>;
  control: FormControl<FormValues>;
  documentCode: string;
  defaultValues: Record<string, any> | Nullish;
}
const SCHEMA_ID = 'customer_message';

export function AdditionalSettings(props: CustomFieldsNotificationSettingsProps) {
  const isAutomatizationEnabled = useWatch({
    control: props.control,
    name: 'enabled',
  });

  const {
    data: schema,
    isLoading: isLoadingSchema,
    isError: isSchemaError,
    error,
  } = useGetSchemaQuery({id: `${SCHEMA_ID}-${props.documentCode}`});

  const isNotFoundError = path(['status'], error) === 404;

  return (
    <Hide when={isNotFoundError || isLoadingSchema}>
      <Separator spacing={0} />

      <Heading size={4}>{i18n.t('page.settings.notifications.anotherSettings')}</Heading>

      <DataStatus minHeight={20} isError={isSchemaError}>
        {schema?.root && (
          <DynamicUi
            schema={schema.root}
            isReadOnly={!isAutomatizationEnabled}
            defaultValues={props.defaultValues ?? {}}
            onChange={(values) => props.formApi.setValue('additionalSettings', values)}
          />
        )}
      </DataStatus>
    </Hide>
  );
}
